import { BUILDING_TYPE, COUNTRY_CODE } from '~/lib/graphql/types';
import type { QuestionItem } from '~/lib/store/types';

import questionsCommercialMy from './commercial-my';
import questionsCommercialSg from './commercial-sg';
import questionsResidentialMy from './residential-my';
import questionsResidentialSg from './residential-sg';

const COMMERCIAL_TYPES = new Set<BUILDING_TYPE>([
    BUILDING_TYPE.OWNED_COMMERCIAL_PROPERTY,
    BUILDING_TYPE.RENTED_COMMERCIAL_PROPERTY
]);

/**
 * Return the question config list for a given country + building type combo.
 */
export function getQuestions(
    countryCode: COUNTRY_CODE,
    buildingType: BUILDING_TYPE
): QuestionItem[] {
    const isCommercial = COMMERCIAL_TYPES.has(buildingType);

    if (countryCode === COUNTRY_CODE.MY) {
        return isCommercial ? questionsCommercialMy : questionsResidentialMy;
    }

    return isCommercial ? questionsCommercialSg : questionsResidentialSg;
}

/** Get the slug for a question item. */
export function getSlug(q: QuestionItem): string {
    return q.slug ?? (q.type !== 'grouped' ? q.input : 'details');
}

/** Find a question by its slug within a question list. */
export function findBySlug(
    questions: QuestionItem[],
    slug: string
): { question: QuestionItem; index: number } | null {
    const index = questions.findIndex((q) => getSlug(q) === slug);
    if (index === -1) return null;
    return { question: questions[index], index };
}

/** Get the first question's slug for a given config. */
export function firstSlug(
    countryCode: COUNTRY_CODE,
    buildingType: BUILDING_TYPE
): string {
    const questions = getQuestions(countryCode, buildingType);
    return getSlug(questions[0]);
}
